const ACTIONS = {
  GET_ZOOM_SETTINGS: "getZoomSettings"
};

export { ACTIONS };
